/**
 *
 * @param {string} birthdayStr
 * @return {{date: null | Date, birthDay: number, birthMonth: number, birthYear: number}}
 */
export const parseBirthday = (birthdayStr) => {
  const date = new Date(birthdayStr)
  if (date === 'Invalid Date') {
    return {
      date: null,
      birthDay: -1,
      birthMonth: -1,
      birthYear: -1
    }
  }

  return {
    date,
    birthDay: date.getDate(),
    birthMonth: date.getMonth(),
    birthYear: date.getFullYear()
  }
}

export const removeDayFromDateString = (dateStr) => {
  return /\d+-\d+-\d+/.test(dateStr)
    ? dateStr.replace(/(-\d+)$/, '') // remove the day part from the date
    : dateStr
}

/**
 * Swap dates, and format so that so that 2020-12-30 becomes 30/12/2020
 * Or formats 2020-12 to December 2020 if showDay is false
 */
export const formatDisplayDates = (dateStr, showDay = true) => {
  if (!dateStr) return ''
  const parts = dateStr.split('-')
  if (showDay) {
    // Expect YYYY-MM-DD
    if (parts.length !== 3) return dateStr // Return original if format is unexpected
    return parts.reverse().join('/') // DD/MM/YYYY
  } else {
    // Expect YYYY-MM
    if (parts.length < 2) return dateStr // Return original if format is unexpected
    const year = parts[0]
    const monthIndex = parseInt(parts[1], 10) - 1
    if (isNaN(monthIndex) || monthIndex < 0 || monthIndex > 11) return dateStr // Invalid month

    // We need MONTH_REFERENCE here, ideally passed in or defined globally
    // For now, let's create a simple month name array
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ]
    const monthName = monthNames[monthIndex]
    return `${monthName} ${year}`
  }
}

export const birthdayStringToOmneoObject = (birthdayStr) => {
  const { birthDay, birthMonth, birthYear } = parseBirthday(birthdayStr)
  return {
    birth_day: birthDay,
    birth_month: birthMonth + 1, // parseBirthday returns 0-11 for months
    birth_year: birthYear
  }
}
